import { render, staticRenderFns } from "./YagiofferSelfPrAppendBox.vue?vue&type=template&id=2ce373e7&scoped=true"
import script from "./YagiofferSelfPrAppendBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiofferSelfPrAppendBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagiofferSelfPrAppendBox.vue?vue&type=style&index=0&id=2ce373e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce373e7",
  null
  
)

export default component.exports